import React, { useState, useEffect } from 'react';
import { useSubmitContactMutation } from '../../store/api/landingApi';
import LandingFooter from '../../components/layouts/LandingFooter';
import { showSuccess, showError } from '../../utils/toast';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Contact: React.FC = () => {
  const [lang] = useState(localStorage.getItem('locale') || 'en');
  const [submitContact, { isLoading }] = useSubmitContactMutation();
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    message: '',
  });

  useEffect(() => {
    AOS.init({ duration: 1000, delay: 300 });
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const result = await submitContact(formData).unwrap();
      setFormData({ name: '', phone: '', email: '', message: '' });
      showSuccess(result?.message || 'Thank you for contacting us! We\'ll get back to you soon.');
    } catch (err: any) {
      showError(err?.data?.message || 'Failed to submit contact form. Please try again.');
    }
  };

  return (
    <>
      <div className="d-flex flex-column bg-base-light flex-center w-100 min-h-300px z-index-n1 min-h-lg-450px px-9 bg-leaves">
        <img src="/media/lemon.png" className="w-325px lemon-img position-absolute right-0 me-15 z-index-0 img-responsive" alt="" />
        <img src="/media/vegetable.png" className="vegetable-img position-absolute z-index-0 img-responsive" alt="" />
        <div className="row w-100 mx-auto">
          <div className="col-md-8 mx-auto text-center">
            <div className="mb-5 mb-lg-10 py-10 py-lg-20">
              <h1 className="text-base-dark lh-base fw-bold fs-1x fs-lg-3x mb-5 text-uppercase font-bold" data-aos="fade-up">Get in touch!</h1>
              <br />
              <p className="text-base-dark fs-lg-3" data-aos="fade-up">We'd love to hear from you.</p>
              <img src="/media/vegetable2.png" className="w-325px vegetable2-img position-absolute z-index-0 img-responsive" alt="" />
              <img src="/media/tomato.png" className="tomato-img position-absolute right-0 z-index-0 img-responsive" alt="" />
              <br />
            </div>
          </div>
        </div>
      </div>
      <img src="/media/Wave.png" className="w-100 curve" alt="" />
      <div className="mb-n10 mb-lg-n20 z-index-2 min-h-300px inner-box">
        <div className="container">
          <div className="row mt-5">
            <div className="col-12 col-md-10 mx-auto shadow bg-white mb-15 inner-content">
              <div className="row">
                <div className="col-md-6 p-10" data-aos="fade-right">
                  <form onSubmit={handleSubmit}>
                    <label className="m-2">Your name*</label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                      required
                      className="form-control custom-input border-secondary mb-8"
                      placeholder="Jullia Wiliam"
                    />
                    <label className="m-2">Mobile number*</label>
                    <input
                      type="number"
                      name="phone"
                      value={formData.phone}
                      onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                      required
                      className="form-control custom-input border-secondary mb-8"
                      placeholder="0091XXXXXXX"
                    />
                    <label className="m-2">Contact email*</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                      required
                      className="form-control custom-input border-secondary mb-8"
                      placeholder="you@example.com"
                    />
                    <label className="m-2">Your message*</label>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                      cols={30}
                      rows={5}
                      required
                      maxLength={200}
                      className="form-control rounded border-secondary mb-3"
                      placeholder="Write your message here..."
                    />
                    <small className="float-end d-block text-danger font-light">Max. 200 characters</small>
                    <br />
                    <p className="fs-lg-6 font-light text-gray-600">By submitting this form you agree to our terms & conditions.</p>
                    <input
                      type="submit"
                      value="Submit"
                      disabled={isLoading}
                      className="btn w-100 p-5 fs-lg-4 btn-base rounded-pill"
                    />
                  </form>
                </div>
                <div className="col-md-6" data-aos="zoom-in" style={{ background: "url('/media/Base.png')", backgroundSize: 'cover' }}>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-10 mx-auto mt-10 mb-15">
              <div className="row" data-aos="zoom-in">
                <div className="col-6 text-center">
                  <img src="/media/email.png" width="60px" alt="" />
                  <p className="lead mt-3">Email Us</p>
                  <p>Email us for general queries, and partnership opportunities.</p>
                  <a href="mailto:contact@saveme.ae" className="text-base">contact@saveme.ae</a>
                </div>
                <div className="col-6 text-center">
                  <img src="/media/phone.png" width="60px" alt="" />
                  <p className="lead mt-3">Call Us</p>
                  <p>Call us to speak to a member of our team. We are always happy to help.</p>
                  <a href="tel:+971 50 573 4522" dir="ltr" className="text-base">+971 50 573 4522</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <LandingFooter />
    </>
  );
};

export default Contact;
